import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
  inject
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  Subject,
  takeUntil
} from 'rxjs';
import { saveAs } from 'file-saver';

import { FileData } from '@shared/models/catalog.service';
import { DocumentService } from '@shared/services/document.service';
import { ServerLinkName } from '@shared/models/server-links-model';
import { ServerLinks } from '@shared/services/server-links';

@Component({
  selector: 'app-catalog-item-card-files-info',
  templateUrl: './catalog-item-card-files-info.component.html',
  styleUrls: ['./catalog-item-card-files-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogItemCardFilesInfoComponent {
  filesData = input.required<FileData[]>();
  hasImage = computed(() => {
    return this.filesData()?.some((file) => file.type.includes('image'));
  });
  serverLinks = inject(ServerLinks);
  document = inject(DOCUMENT);
  documentService = inject(DocumentService);
  destroy$ = new Subject<void>();

  isImage(file: FileData): boolean {
    return file.type.includes('image') && !file.type.includes('svg');
  }

  imageSource(file: FileData): string {
    return `/MEDIA/showFile?id=${file.id}&size=thumbnail`;
  }

  onFileClick(file: FileData, event: Event) {
    event.stopPropagation();

    const id = file.id;
    if (!id) { return; }

    if (this.isImage(file)) {
      if (this.document?.defaultView) {
        const filePath = this.serverLinks.getLink(ServerLinkName.File);
        this.document.defaultView.open(`${filePath}${id}`);
      }
    } else {
      this.documentService.downloadDocumentFile(id)
        .pipe(takeUntil(this.destroy$))
        .subscribe((fileData) => {
          const fileBlob = new Blob([fileData], { type: file.type });
          saveAs(fileBlob, file.fileName);
        });
    }
  }
}
